export { Compare1 } from "./Compare1";